import { Account, useDeleteAccountApi } from '@liquidbudget/common';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import { Checkbox } from '@/components/ui/form/checkbox';

type Props = {
  account: Account;
  onSuccess: () => void;
};

export function AccountDeleteForm({ account, onSuccess }: Props) {
  const { mutate, isPending } = useDeleteAccountApi({ onSuccess });
  const [isConfirmed, setIsConfirmed] = useState(false);

  const onDelete = () => {
    if (!isConfirmed) return;

    mutate({
      budgetId: account.budgetId,
      id: account.id,
    });
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="confirm-delete"
            checked={isConfirmed}
            onCheckedChange={(checked) => setIsConfirmed(checked as boolean)}
          />
          <label
            htmlFor="confirm-delete"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            I understand that this action cannot be undone
          </label>
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <Button
          type="submit"
          variant="destructive"
          disabled={!isConfirmed || isPending}
          isLoading={isPending}
          onClick={onDelete}
        >
          Delete Account
        </Button>
      </div>
    </div>
  );
}
